import { computed } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { IExecutionOptions, IQueryOptions } from '../../../models/commonTypes';
import { IConfigurationComponentOrchestration } from '../../../models/app/IConfigurationComponentOrchestration';
import { StoreContext } from '../../../configuration/StoreContext';
import { EntityStore } from './EntityStore';

export class EntityConsumerStore extends StoreBase {
	entityStore: EntityStore | undefined;
	constructor(storeContext: StoreContext, entityStore?: EntityStore) {
		super(storeContext);
		this.entityStore = entityStore;
	}

	async initialize() { }

	@computed
	get queryStore() {
		return this.entityStore && this.entityStore.queryStore;
	}

	getQueryValue(queryOptions?: IQueryOptions, responseForContext?: object, overrideExecutionOptions?: Partial<IExecutionOptions>) {
		return super.getQueryValue(queryOptions, responseForContext, overrideExecutionOptions, { queryStore: this.queryStore });
	}

	mergeQueriesAndProps<T>(componentOrchestration?: IConfigurationComponentOrchestration, responseContext?: any): T | undefined {
		return super.mergeQueriesAndProps(componentOrchestration, responseContext, { queryStore: this.queryStore });
	}
}